import { config } from '@cotera/client/config/config';
import { useMemo } from 'react';
import { makeTypedClient } from '../etc/api/typed-client';
import { useGetBearerToken } from './use-bearer-token';

export const useClient = () => {
  const getBearerToken = useGetBearerToken();

  return useMemo(
    () =>
      makeTypedClient({
        apiUrl: config.apiUrl,
        getAccessToken: getBearerToken,
      }),
    [getBearerToken]
  );
};
